<div class="footer">
    Copyright <a href="http://www.movisat.com" target="_blank">MOVISAT</a> © {{anno}}
    <div style="float: right; padding-right: 6px;">
        <!-- <sup>API {{mainComponent.apiVersion.apiVer}} / {{mainComponent.apiVersion.libVer}}</sup> -->
        <sup>Ver. {{mainComponent.webVersion}} / API {{mainComponent.apiVersion.apiVer}}</sup>
    </div>
</div>